export default __webpack_public_path__ + "static/media/adding_receipts.9d241fa9.png";